import React from 'react'
import './card.css'

export default function Card({ title, children, inline }) {

    return (
        <div className={`card__container${ inline ? ' card__container--inline' : '' }`}>
            <div className='card'>
                { title ? (<div className='card__title'>{ title }</div>) : null }
                { children }
            </div>
        </div>
    )

}


// WEBPACK FOOTER //
// ./src/components/Card/index.js